import {createAsyncAction} from 'typesafe-actions';
import { AddEditAccountPhonebookRecordPayload, DeleteAccountPhonebookRecordPayload, GetAccountPhonebookListRequest, PhonebookRecord, SetAccountPhoneBookRecordFavoritPayload } from './payloads';
import { APIErrorInterface } from '../../types';

export const getAccountPhoneBookList = createAsyncAction(
    'GET_ACCOUNT_PHONE_BOOK',
    'GET_ACCOUNT_PHONE_BOOK_SUCCESS',
    'GET_ACCOUNT_PHONE_BOOK_FAILED',
)<GetAccountPhonebookListRequest, {list: PhonebookRecord[], total: number}, APIErrorInterface>();

export const addEditAccountPhoneBookRecord = createAsyncAction(
    'ADD_EDIT_ACCOUNT_PHONE_BOOK_RECORD',
    'ADD_EDIT_ACCOUNT_PHONE_BOOK_RECORD_SUCCESS',
    'ADD_EDIT_ACCOUNT_PHONE_BOOK_RECORD_FAILED',
)<AddEditAccountPhonebookRecordPayload, number | null, APIErrorInterface>();

export const deleteAccountPhoneBookRecord = createAsyncAction(
    'DELETE_ACCOUNT_PHONE_BOOK_RECORD',
    'DELETE_ACCOUNT_PHONE_BOOK_RECORD_SUCCESS',
    'DELETE_ACCOUNT_PHONE_BOOK_RECORD_FAILED',
)<DeleteAccountPhonebookRecordPayload, undefined, APIErrorInterface>();

export const setAccountPhoneBookRecordFavorit = createAsyncAction(
    'SET_ACCOUNT_PHONE_BOOK_RECORD_FAVORIT',
    'SET_ACCOUNT_PHONE_BOOK_RECORD_FAVORIT_SUCCESS',
    'SET_ACCOUNT_PHONE_BOOK_RECORD_FAVORIT_FAILED',
)<SetAccountPhoneBookRecordFavoritPayload, undefined, APIErrorInterface>();